export default {
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Contenedor",
    activity: "Actividad",
    quotes: "Cotizaciones",
    orders: "Pedidos",
    receivers: "Destinatarios",
    shippers: "Expedidores",
    team: "Equipo",
    addressBook: "Libreta de Direcciones",
    settings: "Configuración",
    accounts: "Cuentas",
    support: "Soporte",
    logout: "Cerrar sesión",
    documents: "Documentos",
    workflows: "Flujos de Trabajo",
};
